import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, FileText, Settings, LogOut } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function MobileShell({ children, title }) {
  const loc = useLocation();
  const nav = useNavigate();
  const { user, logout } = useAuth();

  const tabs = [
    { to: "/admin", icon: Home, label: "Inbox" },
    { to: "/admin/contracts", icon: FileText, label: "Contracts" },
    { to: "/admin/settings", icon: Settings, label: "Settings" },
  ];

  return (
    <div className="min-h-screen bg-[#F5F5F7] pb-24">
      <header className="sticky top-0 z-40 glass">
        <div className="max-w-3xl mx-auto px-4 h-14 flex items-center justify-between">
          <Link to="/admin" className="flex items-center gap-2" data-testid="admin-brand">
            <img src="/logo.png" alt="" className="h-7 w-auto" />
            <span className="font-display text-sm tracking-tight text-[#0A1930]">{title || "Admin"}</span>
          </Link>
          <div className="flex items-center gap-2">
            {user?.picture && <img src={user.picture} alt="" className="w-7 h-7 rounded-full" />}
            <button onClick={async () => { await logout(); nav("/admin/login"); }}
              className="h-9 px-3 rounded-full text-slate-500 hover:bg-slate-100 text-xs flex items-center gap-1"
              data-testid="admin-logout">
              <LogOut className="w-3.5 h-3.5" />
              <span className="hidden sm:inline">Sign out</span>
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 pt-4">{children}</main>

      <nav className="fixed bottom-0 inset-x-0 z-50 border-t border-slate-200 bg-white/90 backdrop-blur-xl" data-testid="admin-bottom-nav">
        <div className="max-w-3xl mx-auto grid grid-cols-3">
          {tabs.map((t) => {
            const active = loc.pathname === t.to || (t.to === "/admin" && loc.pathname.startsWith("/admin/clients"));
            return (
              <Link key={t.to} to={t.to} data-testid={`bottom-nav-${t.label.toLowerCase()}`}
                className={`flex flex-col items-center justify-center py-3 text-[11px] ${active ? "text-[#0066CC]" : "text-slate-500"}`}>
                <t.icon className={`w-5 h-5 ${active ? "stroke-[2]" : "stroke-[1.5]"}`} />
                <span className="mt-1">{t.label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
